import helpers from '../../helpers'

const AppStream = {

  install (Vue, options) {
    if (!options || !options.http) { throw new Error('Auth plugin expects http module') }

    const http = options.http

    Vue.prototype.$appStream = {

      async getSignedUrl (region) {
        let token = await helpers.storage.get('token')

        let config = {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }

        return new Promise((resolve, reject) => {
          http
            .post(`stream/instance`, region, config)
            .then(response => {
              resolve(response)
            })
            .catch(e => {
              console.log(e)

              reject(e)
            })
        })
      },

      async getStreamingInstances () {
        let token = await helpers.storage.get('token')

        let config = {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }

        return new Promise((resolve, reject) => {
          http
            .get(`stream/instances`, config)
            .then(response => {
              resolve(response)
            })
            .catch(e => {
              console.log(e)

              reject(e)
            })
        })
      },

      async getActiveSessions () {
        let token = await helpers.storage.get('token')

        let config = {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }

        return new Promise((resolve, reject) => {
          http
            .get(`stream/activesessions`, config)
            .then(response => {
              resolve(response)
            })
            .catch(e => {
              console.log(e)

              reject(e)
            })
        })
      }
    }
  }
}

export default AppStream



// WEBPACK FOOTER //
// ./src/services/appstream/index.js